import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import PcmpAuth from "../../hoc/PcmpAuth";
import UserDeactivated from "../common/userDeactivation";
// import CmsLayout from './layout';
import Dashboard from "./dashboard";
import ExecDashboard from "./executiveDashboard";
import ExecDashboardLineItems from "./executiveDashboard/lineItems";
import ExecDashboardBatchItems from "./executiveDashboard/batchItems";
import LineItems from "./lineItems";

// import PurchaseOrders from "./purchaseOrders";
import PurchaseOrderDashboard from "../common/PurchaseOrderIndex/PurchaseOrderDashboard";
import TeamMembers from "../common/teamMembers/TeamMembers";
import InventoryStatusDashboard from "../common/InventoryStatus/InventoryStatusDashboard";
import PurchaseOrders from "./purchaseOrders";
import BatchItems from "./batchItems";
import POBatchItems from "./batchItems/poBatchItems";
import GenealogyReport from "../common/GenealogyReports1/GenealogyReport";

import ManageMembers from "./manageMembers";
import rolesAndAccessDashboard from "../common/rolesAndAccess/rolesAndAccessDashboard";
import ViewPurchaseOrder from "./purchaseOrders/viewPurchaseOrder/purchaseOrder";
import ViewLineItem from "./purchaseOrders/viewPurchaseOrder/lineItems";
import ShortFalls from "./shortFalls";

import Reports from "./reports";
import Settings from "./settings";
import EsdaDashboard from "../common/esda/EsdaDashboard";

import NotFound from "../../notFound/NotFound";
import CmsLayout from "../layout/index";

import GRNReceipts from "../common/grnReceipts/GrnAccess";

// import GRNTestReceipts from '../common/grnReceipts/'
//UserProfile
import UserProfile from "../common/profile/user";
import OrgDetails from "../common/profile/organization";

import WIPComponent from "../common/wip";
import DeliveryScheduleDetails from "../common/sasl/deliverScheduleDetails";

import SASLIndex from "../common/sasl/scheduleAgreements/index";
import SAAuditIndex from "../common/reports/saAudit";

/* Quality event import */
import QualityEventIndex from "../common/qualityEvents/index";
//  import EventInformation from '../common/qualityEvents/raiseQualityEvent/addEvent_BO/EventInformation'
import BatchesDetails from "../common/sasl/batchesDetails";
import ProjectsDashboard from "../common/projectsDashboard";
import UploadPOs from '../common/PurchaseOrderDashbaordIndex/UploadPOs';
import ProjectDeliverables from "../common/projectsDashboard/ProjectDetails/ProjectDeliverables";
import StructuredData from "../common/projectsDashboard/Reports/StructuredData/StructuredData";
import PendingDashboard from "../common/projectsDashboard/PendingDashboard";
import ForecastScheduleIndex from "../common/ForecastSchedule/ForecastScheduleIndex";
import FTEBudget from "../common/projectsDashboard/analytics/FTEBudget";
import TasksDashboard from "../common/projectsDashboard/tasksDashboard/TasksDashboard";
import SitesAndResources from "./sitesAndResorces/SitesAndResources";
import AverageOTIFTrend from "../pharmaCo/poFulfilmentDashboard/averageOTIFTrend";
import InactivePODashboard from '../common/inactivePODashboard';
import PODetails from '../common/inactivePODashboard/PODetails';

import POLineItemDashboard from "../common/purchaseOrderLineItem/POLineItemDashboard";
import AuditReport from "../common/POAuditReport/AuditReport";
import POFulfilmentTabs from "./poFulfilmentDashboard/POFulfilmentTabs";
import PurchaseOrderTabs from "../common/PurchaseOrderIndex/PurchaseOrderTabs";

import ViewComponentAllocation from "./viewComponentAllocation";
import ViewDetailedComponentAllocation from "./viewComponentAllocation/ViewDetailAllocation";
import ViewBatchComponentAllocation from "./viewComponentAllocation/ViewBatchDetails";
import PurchaseOrderDashboardIndex from '../common/PurchaseOrderDashbaordIndex/PurchaseOrderTabs'
import NotificationsDashboard from '../common/NotificationsDashboard/NotificationsDashboard';
import ManageNotifications from '../common/NotificationsDashboard/ManageNotifications';
import ManageDistributionList from '../common/NotificationsDashboard/ManageDistributionList';
import ConfigProductDetails from "./ConfigProductDetails/ConfigProductDetails";
import ProductConfigStepper from "./ConfigProductDetails/Stepper/ProductConfigStepper";
import ViewProduct from "./ConfigProductDetails/ViewProduct/ViewProduct";
import ViewProductEdit from "./ConfigProductDetails/ViewProduct/ViewProductEdit";
// Product Development routes (Clinical Supply - Product Development)
import ClinicalProductDevelopmentStepper from "./ConfigProductDetails/ProductDevelopment/Stepper/ClinicalProductDevelopmentStepper";
import ViewProductDevelopment from "./ConfigProductDetails/ProductDevelopment/View/ViewProductDevelopment";
import ManufactureCertificate from "../common/Digitisation/ManufactureCertificate";
import ConsumptionData from "../common/Digitisation/DigitizedConsumptionPage.jsx";
import PartialManuFactureData from "../common/Digitisation/PartialManufacture.jsx";
import PackingListData from "../common/Digitisation/PackingList.jsx";
import Commercial from "../common/Digitisation/CommercialInvoice.jsx";
import FinishedProduct from "../common/Digitisation/FinishedProduct.jsx";
import DeliveryNotes from "../common/Digitisation/DeliveryNote.jsx";
// import ReasonCodeDashboard from "../common/manageReasonCodeDashboard/ReasonCodeDashboard";
// import MaterialDetailsDashboard from "../common/MaterialDetailsDashboard/MaterialDetailsDashboard";
import BrandDetailsDashboard from "../common/BrandDetails/BrandDetailsDashboard.jsx";
import SponsorNetworkTabs from "../common/SponsorNetworkTabs/SponsorNetworkTabs";
import Update from "../common/sasl/deliveryScheduleBatchTable/ResolveButton.jsx";
import CmosNetwork from "../common/CMONetwork/CmosNetworkDashboard";
import CMOStepper from "../common/CMONetwork/Stepper/CMOStepper.jsx";
import UpdateCMOConfig from "../common/CMONetwork/UpdateCMOConfig.jsx";
import ViewCMOConfig from "../common/CMONetwork/ViewCMOConfig.jsx";
import UpdateCmoConfiguration from "../common/CMONetwork/UpdateCMO/UpdateCmoConfiguration.jsx";
import CMOTeamMembers from "../common/CMONetwork/CMOTeamMembers.jsx";
import ProductDevelopment from "../common/ProjectDevelopment/index.jsx";
import ProductDevelopmentStepper from "../common/ProjectDevelopment/Stepper/ProductDevelopmentStepper";
import ProjectHistory from "../common/ProjectDevelopment/ProjectTabs/projectHistory/ProjectHistory";
import ProjectAnalytics from "../common/ProjectDevelopment/ProjectAnalytics";
import BatchGenealogy from "../common/ProjectDevelopment/BatchGenealogy";
import ReviewDocumentPage from "../common/ProjectDevelopment/ProjectTabs/ReviewDocumentPage";
import AllBatchUpdates from "../common/ProjectDevelopment/ProjectTabs/messages/AllBatchUpdates";
import UploadProductDetails from './ConfigProductDetails/Stepper/steps/UploadProductDetails';
import CertificateOfAnalysis from "../common/Digitisation/CertificateOfAnalysis.jsx";
import DigitizedCommercialInvoice from "../common/Digitisation/DigitizedCommercialInvoice.jsx";
import DigitizedPackingSlip from "../common/Digitisation/DigitizedPackingSlip.jsx";
import BillOfLading from "../common/Digitisation/BillOfLading.jsx";
import DigitizationDashboard from "../common/digitizationDashboard";

import DailyOperationsDashboard from "../common/dailyOperations";
import PODashboard from "../../powerbi/PODashboard";
import MfgCollabDashboard from '../common/manufacturingCollab';
import MfgProjectAnalytics from '../common/manufacturingCollab/ProjectAnalytics';
import ForecastDashboard from "../forecast/ForecastDashboard";
import LogisticsCollaborationDashboard from "../common/logisticsDashboard/LogisticsCollaborationDashboard";
import DocumentRepository from "../common/documentRepository";

const PcmpCmsRoutes = () => (
  <CmsLayout>
    <Switch>
      <Route
        exact
        name="ESDA"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/esda"
        component={PcmpAuth(EsdaDashboard, "Pharma Co")}
      />
      <Route
        exact
        name="PO fulfilment dashboard"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/pofulfilmentdashboard"
        component={POFulfilmentTabs}
        // component={Dashboard}
      />
      <Route
        exact
        name="Projects Dashboard"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/projectsdashboard"
        component={ProjectsDashboard}
        // component={Dashboard}
      />
      <Route
        exact
        name="Average OTIF Report"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/averageOTIFReport"
        component={AverageOTIFTrend}
        // component={Dashboard}
      />

      <Route
        exact
        name="Projects Dashboard"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/tasksDashboard"
        component={TasksDashboard}
        // component={Dashboard}
      />

      <Route
        exact
        name="Project Details"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/projectsdashboard/pendingitems"
        component={PendingDashboard}
      />

      <Route
        exact
        name="Project Details"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/project/:projectName"
        component={ProjectDeliverables}
      />

      <Route
        exact
        name="Project Details"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/projectsdashboard/structuredData"
        component={StructuredData}
      />

      <Route
        exact
        name="Project Details"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/projectsdashboard/FTE-Budget"
        component={FTEBudget}
      />

      <Route
        exact
        name="PCMP Dashboard"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/dashboard"
        component={PcmpAuth(Dashboard, "Pharma Co")}
        // component={Dashboard}
      />
      <Route
        exact
        name="PCMP Dashboard"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/executivedashboard"
        component={PcmpAuth(ExecDashboard, "Pharma Co")}
      />
      <Route
        exact
        name="PCMP Dashboard"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/executivedashboard/lineItems"
        component={PcmpAuth(ExecDashboardLineItems, "Pharma Co")}
      />
      <Route
        exact
        name="PCMP Dashboard"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/executivedashboard/batchItems"
        component={PcmpAuth(ExecDashboardBatchItems, "Pharma Co")}
      />
      <Route
        exact
        name="PCMP All Line Items"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/lineitems"
        component={PcmpAuth(LineItems, "Pharma Co")}
      />
      <Route
        exact
        name="PCMP Purchase Orders"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/purchaseorders"
        component={PcmpAuth(PurchaseOrderTabs, "Pharma Co")}
        // component={PcmpAuth(PurchaseOrderDashboardIndex, "Pharma Co")}
      />
      <Route
        exact
        name="PCMP Purchase Orders"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/purchaseorderManagement"
        component={PcmpAuth(PurchaseOrderDashboardIndex, "Pharma Co")}
      />
      <Route
        exact
        name="Inactive POs"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/inactivePOs"
        component={PcmpAuth(InactivePODashboard, "Pharma Co")}
      />
      <Route
        exact
        name="PO Details"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/inactivePOs/poDetails"
        component={PcmpAuth(PODetails, "Pharma Co")}
      />
      <Route
        exact
        name="Upload POs"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/uploadPOs"
        component={UploadPOs}
      />
      <Route
        exact
        name="PCMP POAuditReport"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/purchaseorders/purchaseOrderAuditReport"
        component={AuditReport}
      />

      <Route
        exact
        name="PCMP Purchase Orders"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/purchaseorders/lineitems"
        component={PcmpAuth(POLineItemDashboard, "Pharma Co")}
      />

      <Route
        exact
        name="PCMP All Batch Items"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/batches"
        component={PcmpAuth(BatchItems, "Pharma Co")}
      />
      <Route
        exact
        name="PCMP All Batch Items for a Purchase Order"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/:purchaseOrderNumber/pobatchitems"
        component={PcmpAuth(POBatchItems, "Pharma Co")}
      />
      <Route
        exact
        name="Manage Members"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/managemembers"
        component={PcmpAuth(ManageMembers, "Pharma Co")}
        // component={ManageMembers}
      />
      <Route
        exact
        name="Roles And Access"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/rolesandaccess"
        component={PcmpAuth(rolesAndAccessDashboard, "Pharma Co")}
      />
      <Route
        exact
        name="Team members"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/teamMembers"
        component={PcmpAuth(TeamMembers, "Pharma Co")}
      />
      <Route
        exact
        name="Inventory status"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/inventoryStatus"
        component={PcmpAuth(InventoryStatusDashboard, "Pharma Co")}
      />
      <Route
        exact
        name="Settings"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/settings"
        component={PcmpAuth(Settings, "Pharma Co")}
      />

      <Route
        exact
        name="View Purchase Order"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/purchaseorderdetails/:purchaseOrderNumber"
        component={PcmpAuth(ViewPurchaseOrder, "Pharma Co")}
      />
      <Route
        exact
        name="View Line Item"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/lineitem/:purchaseOrderNumber/:schrockenPOLineID/:lineItemNumber"
        component={PcmpAuth(ViewLineItem, "Pharma Co")}
      />
      <Route
        exact
        name="Pharma Co Short Falls"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/shortFalls"
        component={PcmpAuth(ShortFalls, "Pharma Co")}
      />
      <Route
        exact
        name="Pharma Co GRN Receipts"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/GRNReceipts"
        // component={PcmpAuth(GRNReceipts, 'Pharma Co')}
        component={GRNReceipts}
      />
      <Route
        exact
        name="Reports"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/reports"
        // component={PcmpAuth(Reports, 'Pharma Co')}
        component={Reports}
      />
      <Route
        exact
        name="SA Audit Reports"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/sa-audit-reports"
        component={SAAuditIndex}
      />

      <Route
        exact
        name="Schedule Line Details"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/sasl/:schrockenDeliveryScheduleID"
        component={DeliveryScheduleDetails}
      />

      <Route
        exact
        name="Profile Page"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/userProfile"
        component={UserProfile}
      />
      <Route
        exact
        name="Organization Profile Page"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/orgProfile"
        component={OrgDetails}
      />
       <Route
        exact
        name="CMOs"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/CMOs"
        component={CmosNetwork}
      />
      <Route
        exact
        name="Manufacturing Collaboration"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/manufacturingcollaboration"
        component={PcmpAuth(MfgCollabDashboard, "Pharma Co")}
      />
      <Route
        exact
        name="Project Analytics"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/manufacturingcollaboration/project-analytics-view"
        component={MfgProjectAnalytics}
      />
      <Route
        exact
        name="Document Repository"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/documentRepository"
        component={DocumentRepository}
      />
      <Route
        exact
        name="Add New Project"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/manufacturingcollaboration/add-new-project"
        component={ProductDevelopmentStepper}
      />
      <Route
        exact
        name="Project History"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/manufacturingcollaboration/project-history/:projectId"
        component={ProjectHistory}
      />
      <Route
        exact
        name="Project Analytics"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/manufacturingcollaboration/project-analytics"
        component={ProjectAnalytics}
      />
      <Route
        exact
        name="Batch Genealogy"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/manufacturingcollaboration/batch-genealogy"
        component={BatchGenealogy}
      />
      <Route
        exact
        name="Review Document"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/manufacturingcollaboration/review-document/:docType/:docId"
        component={ReviewDocumentPage}
      />
      <Route
        exact
        name="All Batch Updates"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/manufacturingcollaboration/all-batch-updates"
        component={AllBatchUpdates}
      />
      
      <Route
        exact
        name="CMOs"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/Certificate"
        component={ManufactureCertificate}
      />
       <Route
        exact
        name="CMOs"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/ConsumptionData"
        component={ConsumptionData}
      />
      <Route
        exact
        name="CMOs"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/Partial"
        component={PartialManuFactureData}
      />
       <Route
        exact
        name="CMOs"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/Packing"
        component={PackingListData}
      />
        <Route
        exact
        name="CMOs"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/Commercial"
        component={Commercial}
      />

<Route
        exact
        name="CMOs"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/FinishedProd"
        component={FinishedProduct}
      />

<Route
        exact
        name="CMOs"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/Delivery"
        component={DeliveryNotes}
      />
      <Route
        exact
        name="CMOs"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/CertificateOfAnalysis"
        component={CertificateOfAnalysis}
      />
      <Route
        exact
        name="CMOs"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/DigitizedCommercialInvoice"
        component={DigitizedCommercialInvoice}
      />
      <Route
        exact
        name="CMOs"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/DigitizedPackingSlip"
        component={DigitizedPackingSlip}
      />
      <Route
        exact
        name="CMOs"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/BillOfLading"
        component={BillOfLading}
      />

     <Route
        exact
        name="CMOTeams"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/CMOTeams"
        component={CMOTeamMembers}
      />
     
        <Route
          exact
          path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/CMOs"
          component={CmosNetwork}
        />
        <Route
          path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/products/:vendorMosymphonyID"
          component={ConfigProductDetails}
        />
    

      <Route
        exact
        name="Product Details Configuration"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/addProduct"
        component={ProductConfigStepper}
      />
      <Route
        exact
        name="Upload Product Details"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/uploadProductDetails"
        component={UploadProductDetails}
      />

      <Route
        exact
        name="CMO Details Configuration"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/addCMO"
        component={CMOStepper}
      />
      <Route
        exact
        name="Update CMO Configuration"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/updateCMO"
        // component={UpdateCMOConfig}
        component={UpdateCmoConfiguration}
      />
      <Route
        exact
        name="Update CMO Configuration"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/viewCMO"
        component={ViewCMOConfig}
      />
      <Route
        exact
        name="View Product Configuration"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/viewProduct"
        component={ViewProduct}
      />
      <Route
        exact
        name="Edit Product Configuration"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/editProduct"
        component={ViewProductEdit}
      />

      {/* Product Development Routes (Clinical Supply - Product Development) */}
      <Route
        exact
        name="Product Development - Add Product"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/productDevelopment/addProduct"
        component={ClinicalProductDevelopmentStepper}
      />
      <Route
        exact
        name="Product Development - View Product"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/productDevelopment/viewProduct"
        component={ViewProductDevelopment}
      />
      <Route
        exact
        name="Product Development - Edit Product"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/productDevelopment/editProduct"
        component={ViewProductDevelopment}
      />

      <Route
        exact
        name="Products"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/products"
        component={ConfigProductDetails}
      />
      <Route
        exact
        name="Brand Details"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/branddetails"
        component={BrandDetailsDashboard}
      />
      <Route
        exact
        name="Sponsor Network"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/sponsornetwork"
        component={SponsorNetworkTabs}
      />
      {/* <Route
        exact
        name="Manage Reason Codes"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/managereasoncodes"
        component={ReasonCodeDashboard}
      /> */}
      {/* <Route
        exact
        name="Material Details"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/materialdetails"
        component={MaterialDetailsDashboard}
      /> */}

      <Route
        exact
        name="Schedule Agreements"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/schedule agreements"
        component={SASLIndex}
      />

      <Route
        exact
        name="Schedule Agreements"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/forecastSchedule"
        component={ForecastScheduleIndex}
      />

      {/* Quality Event  */}
      <Route
        exact
        name="Quality Events"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/quality events"
        component={QualityEventIndex}
        //component={EventInformation}
      />

      {/* SA SL test screens route */}

      <Route
        exact
        name="SA SL Screen test"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/userdeactivate"
        component={UserDeactivated}
      />

      <Route
        exact
        name="Help"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/help"
        component={WIPComponent}
      />
      <Route
        exact
        name="Switch Ecosystems"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/switch ecosystem"
        component={WIPComponent}
      />

      {/* Batch Dashboard */}
      <Route
        exact
        name="PCMP All Batches"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/fgBatches"
        component={BatchesDetails}
      />
      <Route
        exact
        name="genealogy reports"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/genealogyReports"
        component={GenealogyReport}
      />

      <Route
        exact
        name="PCMP All Batches"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/fgBatches/:batchNo"
        component={BatchesDetails}
      />

      <Route
        exact
        name="Sites and resources"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/sitesAndResources"
        component={SitesAndResources}
      />

      {/* View component allocation route */}
      <Route
        exact
        name="View Component Allocation"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/viewComponentAllocation"
        // component={ViewComponentAllocation}
        component={PcmpAuth(ViewComponentAllocation, "Pharma Co")}
      />
      {/* View detailed component allocation page route */}
      <Route
        exact
        name="View Component Allocation"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/viewDetailedComponentAllocation"
        // component={ViewDetailedComponentAllocation}
        component={PcmpAuth(ViewDetailedComponentAllocation, "Pharma Co")}
      />
      {/* View batches component allocation page route */}
      <Route
        exact
        name="View Component Allocation"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/viewBatchComponentAllocation"
        // component={ViewBatchComponentAllocation}
        component={PcmpAuth(ViewBatchComponentAllocation, "Pharma Co")}
      />

           <Route
        exact
        name="Digitization Dashboard"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/digitizationdashboard"
        component={DigitizationDashboard}
      />

      <Route
        exact
        name="Notifications"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/notifications"
        component={NotificationsDashboard}
      />

      <Route
        exact
        name="Manage Notifications"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/manage-notifications"
        component={ManageNotifications}
      />

      <Route
        exact
        name="Manage Distribution List"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/manage-distribution-list"
        component={ManageDistributionList}
      />

      <Route
        exact
        name="Daily Operations Dashboard"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/dailyoperationsdashboard"
        component={DailyOperationsDashboard}
      />

      <Route
        exact
        name="Daily Operations Dashboard"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/dailyoperationsdashboard"
        component={DailyOperationsDashboard}
      />
      
      <Route
        exact
        name="Analytics"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/analytics"
        component={PODashboard}
      />

       <Route
        exact
        name="Manufacturing Collaboration"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/manufacturingcollaboration"
        component={PcmpAuth(MfgCollabDashboard, "Pharma Co")}
      />

      <Route
        exact
        name="Project Analytics"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/manufacturingcollaboration/project-analytics-view"
        component={MfgProjectAnalytics}
      />

      <Route
        exact
        name="Forecast Dashboard"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/forecast"
        component={PcmpAuth(ForecastDashboard, "Pharma Co")}
      />

      <Route
        exact
        name="Logistics Collaboration Dashboard"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/logistics"
        component={PcmpAuth(LogisticsCollaborationDashboard, "Pharma Co")}
      />

      <Route
        exact
        name="404 Not Found"
        path="/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/*"
        component={NotFound}
      />
      
      {/* route for econd dialougebox */}
      {/* <Route
        exact
        name='Quality Events Dialouge2'
        path='/pcmp/Pharma Co/:roleName/:organizationName/:ecosystemId/quality events/dashboard2'
        component={EventInformation}
      /> */}

      <Route name="404 Not Found" component={NotFound} />
    </Switch>
  </CmsLayout>
);

export default PcmpCmsRoutes;
